import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Divider, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CarrierInfo = ({ carrier, trackingNumber }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!carrier) return null

  return (
    <>
      <Divider />
      <Styles.Container>
        <Text type="allCapsM" customStyles={{ textTransform: 'uppercase', color: theme.colors.grey.tone500 }}>
          {t('Transportista')}
        </Text>
        <Styles.CarrierContainer>
          <Styles.CarrierLogoAndNameContainer>
            <Styles.CarrierLogo src={carrier?.logo_url} alt={carrier?.name} />
            <Text type="bodyMRegular">{carrier?.name}</Text>
          </Styles.CarrierLogoAndNameContainer>
          {trackingNumber && (
            <Text type="bodySRegular" customStyles={{ color: theme.colors.grey.tone600 }}>
              #{trackingNumber}
            </Text>
          )}
        </Styles.CarrierContainer>
      </Styles.Container>
    </>
  )
}

export default CarrierInfo
